<script setup lang="ts">
  import { computed } from 'vue';
  import { DocumentRevisionStatusDot } from '@/shared/ui';
  import { formatDocumentPrefix, DocumentType } from '@/shared/lib';
  import { getDocumentRevisionStatusLabelForType, type DocumentRevision } from '@/entities/Document';
  import ListingActions from './ListingActions.vue';

  const props = defineProps<{
    revision: DocumentRevision;
  }>();

  const statusLabel = computed(() =>
    getDocumentRevisionStatusLabelForType(props.revision, DocumentType.DOCUMENT, '-')
  );
</script>

<template>
  <tr class="table-row-hover border-t border-gray-02 transition-colors duration-300 ease-out">
    <!-- Prefixo -->
    <td class="pl-6 pr-0 py-3 text-sm text-gray-07">
      {{ formatDocumentPrefix(revision.document?.prefix) }}
    </td>
    <!-- Título -->
    <td class="pl-6 pr-0 py-3">
      <div class="flex min-w-0 items-center gap-2">
        <span class="truncate text-sm text-gray-07">
          {{ revision.document?.name }}
        </span>
      </div>
    </td>
    <!-- Status -->
    <td class="px-0 py-3">
      <div class="flex items-center justify-center">
        <DocumentRevisionStatusDot
          :status="revision.status"
          :label="statusLabel"
        />
      </div>
    </td>
    <!-- Ações -->
    <td class="pl-6 pr-0 py-3 text-sm text-gray-07">
      <ListingActions :document="revision" />
    </td>
  </tr>
</template>
